import * as React from "react";
import { Typography, Box, CircularProgress, Stack } from "@mui/material";
import { connect } from "react-redux";
import { centered_flex_box } from "../../app/components/Styles";
import { useNavigate, useParams } from "react-router-dom";
import { acceptInvitation, getInvitation, rejectInvitation } from "../../app/store/actions/commonActions";
import { Image } from "antd";
import { MarketingPage, MarketingCard, MarketingButton } from "../../app/components/marketing";
import {
  marketingColors,
  marketingFonts,
  sectionTitleSx,
} from "../../app/components/tickitMarketingTheme";

export const AcceptInvitation = ({ invitation, getInvitation, isLoading, isError, acceptInvitation }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    getInvitation({ invitationId: id });
  }, []);

  const handleAccept = () => {
    acceptInvitation({ invitationId: id });
  };

  const handleReject = () => {
    navigate(`/invitation/reject/${id}`);
  };

  if (isLoading) {
    return (
      <MarketingPage>
        <Box sx={{ ...centered_flex_box, py: 8 }}>
          <CircularProgress sx={{ color: marketingColors.p700 }} />
        </Box>
      </MarketingPage>
    );
  }

  return (
    <MarketingPage maxWidth="sm">
      {isError ? (
        <MarketingCard>
          <Typography sx={{ ...sectionTitleSx, fontSize: "1.5rem", textAlign: "center" }}>
            Something went wrong
          </Typography>
        </MarketingCard>
      ) : invitation?.status === "Accepted" ? (
        <MarketingCard>
          <Typography sx={{ ...sectionTitleSx, fontSize: "1.5rem", textAlign: "center", mb: 1 }}>
            Invitation accepted!
          </Typography>
          <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.p700, textAlign: "center", fontSize: "1.25rem" }}>
            See you there
          </Typography>
        </MarketingCard>
      ) : (
        <Stack spacing={3}>
          {invitation?.event?.image && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Image src={invitation.event.image} style={{ maxWidth: "100%", borderRadius: 12 }} />
            </Box>
          )}
          <MarketingCard title="Event Terms & Conditions">
            <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray600, lineHeight: 1.7 }}>
              {invitation?.event?.terms}
            </Typography>
          </MarketingCard>
          {invitation?.event?.sponsorsImage && (
            <MarketingCard title="Sponsored by">
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Image src={invitation.event.sponsorsImage} style={{ maxWidth: "100%" }} />
              </Box>
            </MarketingCard>
          )}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
            <MarketingButton onClick={handleAccept} fullWidth sx={{ maxWidth: { sm: 200 } }}>
              Accept
            </MarketingButton>
            <MarketingButton variant="danger" onClick={handleReject} fullWidth sx={{ maxWidth: { sm: 200 } }}>
              Reject
            </MarketingButton>
          </Stack>
        </Stack>
      )}
    </MarketingPage>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.wait?.isLoading || state?.records?.isLoading,
  isError: state?.wait?.isError || state?.records?.isError,
  invitation: state?.records?.results?.invitation,
});

const mapDispatchToProps = { acceptInvitation, getInvitation, rejectInvitation };

export default connect(mapStateToProps, mapDispatchToProps)(AcceptInvitation);
